module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "loader__background"
  }), _c('div', {
    staticClass: "loader__content"
  }, [_c('span', {
    staticClass: "spinner"
  }), _c('transition-wrapper', {
    attrs: {
      "name": "fade"
    }
  }), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(this.$t('load') !== 'load') ? _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('load')))]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a273b74c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/the-loader.vue
// module id = 499
// module chunks = 0